import { Component, EventEmitter, OnInit, Output, } from '@angular/core';


import { BehaviorSubject, Observable } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { LayoutService } from 'src/app/models/auth/_services/layout.service';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { PageService, SpinnerService } from 'src/app/services/service.index';
import { Page } from 'src/app/models/page.model';
@Component({
  selector: 'app-boardcomponent',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.scss'],
})

export class boardcomponent implements OnInit {
    @Output() close = new EventEmitter<any>();
  extrasQuickActionsOffcanvasDirectionCSSClasses = '';
  tabsdata: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  url: BehaviorSubject<SafeResourceUrl> = new BehaviorSubject<SafeResourceUrl>('');
  data: any;
  urlt: string;
  name: string;
  dimensions: string;
  urlObserver$: Observable<SafeResourceUrl>;
  variable:boolean;
  

  constructor( private _pageService: PageService,private _spinnerService: SpinnerService,private modalService: NgbModal, private sanitizer: DomSanitizer, private layout: LayoutService, public microapplicationService: MicroapplicationService) {
    this.urlObserver$ = this.url.asObservable();

  }

  ngOnInit(): void {
    
    this.dimensions = `width: 100%; height:${this.gridHeight()}px;border:none`;
    this.Listdashboard();
    this.extrasQuickActionsOffcanvasDirectionCSSClasses = `offcanvas-${this.layout.getProp(
      'extras.quickActions.offcanvas.direction'
    )}`;
 
  }
  open( tablero: any) {
    this.variable=true;

      setTimeout(() => {
        this.variable=false;
    }, 10000);

    let url =tablero.url + "//?tipo=V&reportUri=" + tablero.code;
    this.name=tablero.name.esCO;

    this._spinnerService.loading();
    const page: Page = {
      codProg:  this.name,
      name:  this.name,
      idForm: null,
      id: 453,
      url: url,
      cambiarUrl: true,
      // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
      typeForm: 'maestro',
      lisnk:null
    };
    this.removeClass('open-item');
    this._spinnerService.close();
  
      this._pageService.generarPage(page);
      this.closeEmit();

  
  }
  closeEmit() {
    this.close.emit(1);
  }

  removeClass = (classs: string) => {
    let nodes = document.querySelectorAll(`.${classs}`);
    nodes.forEach(node => {
      node.classList.remove(classs)
    })
  }

  
  Listdashboard() {
    this.microapplicationService.GetAllMicroApplicationsTabs().subscribe(resp => {

      if (resp.isSuccessful) {
        this.tabsdata.next(resp.result);
        this.data = this.tabsdata.value;
      }
      else {

      }
    });

  }

  gridHeight = () => {
    return Math.round(window.innerHeight / 1);
  }


}
